import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "./Reveal";
import { FEATURES } from "@/lib/site";

export const WhyLark = () => (
  <section id="why" data-testid="why-section" className="bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="max-w-2xl">
        <Reveal>
          <SectionLabel>Why Lark</SectionLabel>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-display text-4xl md:text-5xl font-semibold tracking-tight text-lark-ink leading-[1.1]">
            Built for the demands of the modern enterprise
          </h2>
        </Reveal>
      </div>

      <div className="mt-16 divide-y divide-gray-100 border-t border-gray-100">
        {FEATURES.map((f, i) => {
          const Icon = f.icon;
          return (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="group grid md:grid-cols-[80px_1fr_auto] items-start md:items-center gap-4 md:gap-10 py-8"
              data-testid={`why-item-${i}`}
            >
              <span className="font-display text-sm font-semibold text-lark-blue tracking-[0.2em]">
                0{i + 1}
              </span>
              <div className="flex items-start gap-5">
                <span className="grid place-items-center h-12 w-12 rounded-xl bg-lark-light text-lark-blue shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <Icon size={22} />
                </span>
                <div>
                  <h3 className="font-display text-2xl font-semibold text-lark-ink">{f.title}</h3>
                  <p className="mt-2 text-lark-muted leading-relaxed max-w-xl">{f.desc}</p>
                </div>
              </div>
              <span className="hidden md:block h-px w-16 bg-gray-200 group-hover:w-24 group-hover:bg-lark-blue transition-[width,background-color] duration-300 justify-self-end" />
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
